import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useCRUDSocket } from '../../../../utils/socket/socket'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { cleanWhenEnabledFilterIsSet } from '../../../_helpers/filterByEnabled'

const Context = React.createContext()
const { Provider } = Context
export const useAssetsState = () => React.useContext(Context) || {}
export const useAssets = () => useAssetsState()?.assets || []

const QUERY = gql`
  query Assets($page: Int, $limit: Int, $search: String, $sort: AssetSort, $filter: AssetFilter) {
    assets(page: $page, limit: $limit, search: $search, sort: $sort, filter: $filter) {
      id
      name
      enabled
      place {
        id
        name
        resume
        type
      }
      type {
        id
        name
        entity
        deleted
      }
      deleted
      insertedAt
      updatedAt
    }
  }
`

const AssetsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const response = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      filter: { ...cleanWhenEnabledFilterIsSet({ ...filter, includeDisabled: true }) }
    },
    client: placesClient
  })

  const { data, fetchMore, variables, ...state } = response

  useCRUDSocket('assets', response)

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default AssetsLoader
